import { Send } from 'lucide-react';

interface IconProps {
  className?: string;
  size?: number;
  strokeWidth?: number;
}

export function SendIcon({ className = '', size = 24, strokeWidth = 1.5 }: IconProps) {
  return (
    <Send
      width={size}
      height={size}
      strokeWidth={strokeWidth}
      className={className}
    />
  );
}
